import config from '@akerolabs/email-templates/src/utils/config'

import {
  isObject,
  uuid,
  cloneObject,
} from '@akerolabs/akero-vue/src/utils/helpers'

import {
  newBlock,
  newHTML,
  newImage,
  newSignature,
  newDivider,
} from '@akerolabs/email-templates/src/utils/helpers'

const defaultSpacing = 10

export function defaultBlockSettings(defaultSettings = {}) {
  return Object.assign({}, defaultSettings, {
    background: '#ffffff',
    spacing: {
      top: defaultSpacing,
      right: defaultSpacing,
      bottom: defaultSpacing,
      left: defaultSpacing,
    },
  })
}

export function contentBlock(template) {
  const block = newBlock('oneColumn', [newHTML(template.body)])
  block.settings = defaultBlockSettings(block.settings)
  return block
}

export function convertDefault(template) {
  const content = contentBlock(template)
  content.settings.flushSpacing = true
  return [content]
}

export function convertStandard(template) {
  const content = contentBlock(template)
  content.settings.flushSpacing = false
  return [content]
}

export function convertBanner(template) {
  const content = contentBlock(template)
  const block = newBlock('oneColumn', [newImage(template.media.img.src)])
  block.settings = defaultBlockSettings(block.settings)
  block.settings.flushSpacing = true
  return [block, content]
}

export function convertCompany(template) {
  const content = contentBlock(template)
  const block = newBlock('threeColumn', [
    [],
    [newImage(template.media.img.src)],
    [],
  ])
  block.settings = defaultBlockSettings(block.settings)
  return [block, content]
}

export function createSignatureBlock(template) {
  const children = [newSignature(template.opts.signature.id)]

  if (template.style === 'default') {
    const styles = cloneObject(config.defaultDividerOptions)
    styles.borderColor = 'rgb(255, 255, 255)'
    children.unshift(newDivider(styles))
  }

  const block = newBlock('oneColumn', children)

  if (template.style === 'default') {
    block.settings.flushSpacing = true
  }

  return block
}

export function convertTemplate(template) {
  if (!isObject(template.settings)) {
    template.settings = Object.assign({}, {}, config.defaultTemplateStyles)
  }

  // we need to ensure that the uuid's on all blocks are different or the UI
  // will not work properly we are going to use this to keep track of all
  // the uuid's that have beeb used on the template, when checking the block
  // we will change it's uuid if it is found in this array.
  const usedIds = []

  // If we have fetched a version 1 template then we are going to have to
  // convert it to the new format so that it will render correctly in the
  // new template library
  if (template.version < 2) {
    switch (template.style) {
      case 'banner':
        template.blocks = convertBanner(template)
        template.settings.background = '#f1f1f3'
        break
      case 'company':
        template.blocks = convertCompany(template)
        template.settings.background = '#f1f1f3'
        break
      case 'standard':
        template.blocks = convertStandard(template)
        template.settings.background = '#f1f1f3'
        break
      default:
        template.blocks = convertDefault(template)
        template.settings.background = '#ffffff'
        break
    }

    if (
      isObject(template.opts) &&
      isObject(template.opts.signature) &&
      template.opts.signature.enabled
    ) {
      const signature = createSignatureBlock(template)
      if (isObject(signature)) {
        template.blocks.push(signature)
      }
    }

    template.version = 2
    template.style = 'custom'
  }

  template.blocks.map((block) => {
    if (!block.uuid || usedIds.indexOf(block.uuid) !== -1) {
      block.uuid = uuid()
      usedIds.push(block.uuid)
    }
    if (!block.settings) {
      block.settings = { ...config.defaultBlockOptions }
    }
    return block
  })

  return template
}
